import React from 'react';
import { DatePicker as Original } from 'antd';
export default class Input extends React.PureComponent {
    render() {
        const { forwardedRef, ...otherProps } = this.props;
        return React.createElement(Original, Object.assign({ ref: forwardedRef }, otherProps));
    }
}
